<div class="container fw-b">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>

<div class="profile-shell business-form-shell">
  <section class="profile-hero">
    <div class="profile-hero__cover"></div>
    <div class="profile-hero__content">
      <div class="identity-card">
        <div class="identity-card__media">
          <img src="assets/images/man.png" alt="Business owner" class="identity-card__avatar" />
                            </div>
        <div class="identity-card__copy">
          <h1>{{ businessform?.value?.company || 'Business Profile' }}</h1>
          <p>{{ businessform?.value?.email || 'Complete the form to update business details' }}</p>
          <div class="pill-group">
            <span class="pill pill-primary" *ngIf="businessform?.value?.keepStock !== null">
              {{ businessform?.value?.keepStock ? 'Stock On-hand' : 'Made-to-order' }}
            </span>
            <span class="pill pill-soft" *ngIf="businessform?.value?.monthlyRevenue">
              {{ businessform?.value?.monthlyRevenue }}
            </span>
                        </div>
                            </div>
                        </div>

      <div class="stat-grid">
        <article class="stat-card">
          <span>Unique Products</span>
          <strong>{{ businessform?.value?.numberproducts || '—' }}</strong>
        </article>
        <article class="stat-card">
          <span>Business Reg No.</span>
          <strong>{{ businessform?.value?.businessRegNumber || '—' }}</strong>
        </article>
        <article class="stat-card">
          <span>VAT Status</span>
          <strong>{{ businessform?.value?.vatRegistered ? 'Registered' : 'Not provided' }}</strong>
        </article>
                    </div>
                        </div>
  </section>

  <section class="profile-details-card">
    <div class="details-header">
      <div>
        <p class="eyebrow-text">Business Center</p>
        <h2>Edit Business Details</h2>
                            </div>
      <span class="badge-live">Active</span>
                        </div>

    <form [formGroup]="businessform" class="edit-form">
      <div class="form-section">
        <div class="section-heading">
          <h3>Business Owner / Director Details</h3>
                    </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">First Name<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="fName"
              (keypress)="preventSpace($event)"
              maxlength="32"
              placeholder="Enter first name"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('fName')?.hasError('required') && businessform.get('fName')?.touched">
              Please enter valid first name.
                        </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('fName')?.hasError('minlength') && businessform.get('fName')?.dirty">
              *Please enter minimum 2 character.
                            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('fName')?.hasError('pattern') && businessform.get('fName')?.dirty">
              Please enter valid first name.
                            </div>
                                </div>

          <div class="form-field">
            <label class="form-label">Last Name<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="lName"
              (keypress)="preventSpace($event)"
              maxlength="32"
              placeholder="Enter last name"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('lName')?.hasError('required') && businessform.get('lName')?.touched">
              Please enter valid last name.
                            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('lName')?.hasError('minlength') && businessform.get('lName')?.dirty">
              *Please enter minimum 2 character.
                        </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('lName')?.hasError('pattern') && businessform.get('lName')?.dirty">
              Please enter valid last name.
                    </div>
                            </div>

          <div class="form-field">
            <label class="form-label">Email Address<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="email"
              (keypress)="preventSpace($event)"
              maxlength="250"
              placeholder="Enter email"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('email')?.hasError('required') && businessform.get('email')?.touched">
              *Email is required.
            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('email')?.hasError('pattern') && businessform.get('email')?.dirty">
              *Please enter a valid email.
                                        </div>
                                    </div>

          <div class="form-field">
            <label class="form-label">Phone Number (optional)</label>
            <input
              type="text"
              class="form-control"
              formControlName="Phone"
              (keypress)="preventSpace($event); restrictChar($event); NumOnly($event)"
              maxlength="17"
              placeholder="Enter phone number"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('Phone')?.hasError('required') && businessform.get('Phone')?.touched">
              *Mobile number is required.
            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('Phone')?.hasError('pattern') && businessform.get('Phone')?.dirty">
              Please enter valid Mobile number.
                                    </div>
                                </div>
                            </div>
                        </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Product Details</h3>
        </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">Number Of Unique Products<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="numberproducts"
              (keypress)="preventSpace($event); restrictChar($event); NumOnly($event)"
              maxlength="17"
              placeholder="Enter quantity"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('numberproducts')?.hasError('required') && businessform.get('numberproducts')?.touched">
              Please enter number.
                    </div>
                            </div>

          <div class="form-field form-field--full">
            <label class="form-label">List Of Brands Or Products<span class="astrict">*</span></label>
            <div class="dynamic-list">
              <div class="dynamic-list__item" *ngFor="let item of addNewSubcategoryField; let i = index">
                <input 
                  type="text"
                  class="form-control"
                  placeholder="Enter brand or product"
                  [(ngModel)]="item.sub_Category_List"
                  [ngModelOptions]="{ standalone: true }"
                  (keypress)="preventSpace($event)"
                />
                <button
                  type="button"
                  class="icon-only danger"
                  *ngIf="addNewSubcategoryField?.length > 1"
                  (click)="removeBodySectionDynamic(i)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <button type="button" class="chip-button" (click)="addNewSubCategryDynamic()">
              <i class="fa fa-plus"></i>
              Add another brand
            </button>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-field form-field--full">
            <label class="form-label">Do you keep stock?<span class="astrict">*</span></label>
            <div class="option-group">
              <label class="chip-option">
                <input type="radio" [value]="true" formControlName="keepStock" />
                <span>Yes</span>
              </label>
              <label class="chip-option">
                <input type="radio" [value]="false" formControlName="keepStock" />
                <span>No</span>
            </label>
        </div>
    </div>
</div>

        <div class="form-grid">
          <div class="form-field form-field--full">
            <label class="form-label">Do you have a physical store? (Optional)</label>
            <div class="option-group option-group--stack">
              <label class="chip-option chip-option--wide">
                <input type="radio" (click)="openesd()" [value]="true" formControlName="isPhysicalStore" name="isPhysicalStore" />
                <span>Yes, I have a store</span>
              </label>
              <label class="chip-option chip-option--wide">
                <input type="radio" (click)="closeesd()" [value]="false" formControlName="isPhysicalStore" name="isPhysicalStore" />
                <span>No, I sell through other channels</span>
              </label>
            </div>
          </div>
                                        </div>

        <div class="form-grid" *ngIf="showInputes">
          <div class="form-field">
            <label class="form-label">Store Name</label>
            <input type="text" class="form-control" formControlName="storeess" (keypress)="preventSpace($event)" maxlength="15" placeholder="Enter store name" />
            <div class="for-validation text-danger" *ngIf="businessform.get('storeess')?.hasError('required') && businessform.get('storeess')?.touched">
              *Store name is required.
            </div>
          </div>
          <div class="form-field">
            <label class="form-label">Store Address</label>
            <input type="text" class="form-control" formControlName="storeessed" (keypress)="preventSpace($event)" maxlength="15" placeholder="Enter store address" />
            <div class="for-validation text-danger" *ngIf="businessform.get('storeessed')?.hasError('required') && businessform.get('storeessed')?.touched">
              *Store address is required.
            </div>
          </div>
          <div class="form-field">
            <label class="form-label">Store Contact</label>
            <input type="text" class="form-control" formControlName="storesgg" (keypress)="preventSpace($event)" maxlength="15" placeholder="Enter store contact" />
            <div class="for-validation text-danger" *ngIf="businessform.get('storesgg')?.hasError('required') && businessform.get('storesgg')?.touched">
              *Store contact is required.
                                        </div>
                                        </div>
                                    </div>
                        </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Preferred Partners & Comments (Optional)</h3>
                    </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">Preferred suppliers / wholesalers</label>
            <div class="datalist-field">
              <input
                list="id-car"
                class="form-control"
                [(ngModel)]="srarchWholeSaler"
                [ngModelOptions]="{ standalone: true }"
                (keypress)="preventSpace($event)"
                (ngModelChange)="filter()"
                placeholder="Search supplier by name"
              />
                                <datalist id="id-car">
                <option *ngFor="let car of wholeSalerList" [value]="car.firstName">
                  {{ car.firstName }}
                                    </option>
                                </datalist>
                            </div>
            <div class="selected-suppliers" *ngFor="let hero of selectedCarObjS">
              <div class="selected-chip" *ngIf="hero?.firstName">
                <span>{{ hero.firstName }}</span>
                <button type="button" class="icon-only danger" *ngIf="selectedCarObjS?.length > 1" (click)="removeSearchDynamic(1)">
                  <i class="fa fa-trash"></i>
                </button>
                                </div>
                            </div>
                        </div>
          <div class="form-field">
            <label class="form-label">Additional Comment?</label>
            <textarea
              class="form-control textarea"
              id="exampleFormControlTextarea1"
              formControlName="additional"
              (keypress)="preventSpace($event)"
              placeholder="Enter additional comments"
              rows="3"
            ></textarea>
                            </div>
                        </div>
                    </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Business Details</h3>
        </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">Company Name<span class="astrict">*</span></label>
            <input type="text" class="form-control" formControlName="company" (keypress)="preventSpace($event)" placeholder="Enter company name" />
            <div class="for-validation text-danger" *ngIf="businessform.get('company')?.hasError('required') && businessform.get('company')?.touched">
              *Company name is required.
            </div>
                        </div>
          <div class="form-field">
            <label class="form-label">Business Registration Number<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="businessRegNumber"
              maxlength="17"
              (keypress)="preventSpace($event)"
              placeholder="Enter registration number"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('businessRegNumber')?.hasError('required') && businessform.get('businessRegNumber')?.touched">
              *Registration number is required.
                        </div>
                    </div>
          <div class="form-field">
            <label class="form-label">Monthly Revenue<span class="astrict">*</span></label>
            <select class="form-control" formControlName="monthlyRevenue">
                                    <option value="">Select Monthly Revenue</option>
                                    <option value="Less than R20k">Less than R20k</option>
                                    <option value="R20k to R50k days">R20k - R50k</option>
                                    <option value="R20k to R50k days">R20k - R50k</option>
                                    <option value="More than R500k">More than R500k</option>
                                </select>
                            </div>
          <div class="form-field">
            <label class="form-label">Website's URL (Optional)</label>
            <input type="text" class="form-control" formControlName="url" (keypress)="preventSpace($event)" placeholder="Enter website URL" />
            <div class="for-validation text-danger" *ngIf="businessform.get('url')?.hasError('pattern') && businessform.get('url')?.dirty">
              *Please enter valid URL.
                            </div>
                        </div>
                    </div>

        <div class="form-grid">
          <div class="form-field form-field--full">
            <label class="form-label">Are you VAT registered?</label>
            <div class="option-group">
              <label class="chip-option">
                <input (click)="open()" type="radio" [value]="true" formControlName="vatRegistered" />
                <span>Yes</span>
              </label>
              <label class="chip-option">
                <input (click)="close()" type="radio" [value]="false" formControlName="vatRegistered" />
                <span>No</span>
                                        </label>
                                    </div>
            <div class="inline-field" *ngIf="showInput">
              <input
                type="text"
                class="form-control"
                formControlName="vatNumberInput"
                (keypress)="preventSpace($event)"
                maxlength="15"
                placeholder="Enter VAT number"
              />
              <div class="for-validation text-danger" *ngIf="businessform.get('vatNumberInput')?.hasError('required') && businessform.get('vatNumberInput')?.touched">
                *VAT registered number is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Business Banking Details</h3>
                        </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">Bank Name<span class="astrict">*</span></label>
            <input type="text" class="form-control" formControlName="bankname" (keypress)="preventSpace($event)" placeholder="Enter bank name" />
            <div class="for-validation text-danger" *ngIf="businessform.get('bankname')?.hasError('required') && businessform.get('bankname')?.touched">
              *Please enter bank name.
                            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('bankname')?.hasError('pattern') && businessform.get('bankname')?.touched">
              *Invalid bank name.
                                </div>
                            </div>
          <div class="form-field">
            <label class="form-label">Branch Name<span class="astrict">*</span></label>
            <input type="text" class="form-control" formControlName="branchname" (keypress)="preventSpace($event)" placeholder="Enter branch name" />
            <div class="for-validation text-danger" *ngIf="businessform.get('branchname')?.hasError('required') && businessform.get('branchname')?.touched">
              *Branch name is required.
                        </div>
                    </div>
          <div class="form-field">
            <label class="form-label">SWIFT Code<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="swiftcode"
              maxlength="11"
              (keypress)="preventSpace($event)"
              (input)="toUpperCase($event)"
              placeholder="Enter SWIFT code"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('swiftcode')?.hasError('required') && businessform.get('swiftcode')?.touched">
              *SWIFT code is required.
            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('swiftcode')?.hasError('pattern') && businessform.get('swiftcode')?.dirty">
                                    *SWIFT code must be 8 or 11 uppercase alphanumeric characters.
                                </div>
                            </div>
          <div class="form-field">
            <label class="form-label">Account Number<span class="astrict">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="accountNumber"
              (keypress)="NumOnly($event)"
              maxlength="17"
              placeholder="Enter account number"
            />
            <div class="for-validation text-danger" *ngIf="businessform.get('accountNumber')?.hasError('required') && businessform.get('accountNumber')?.touched">
              *Account number is required.
                        </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('accountNumber')?.hasError('pattern') && businessform.get('accountNumber')?.dirty">
              *Account number must contain only digits.
                            </div>
            <div class="for-validation text-danger" *ngIf="businessform.get('accountNumber')?.hasError('minlength') && businessform.get('accountNumber')?.dirty">
              *Account number must be at least 5 digits.
                        </div>
                    </div>
          <div class="form-field">
            <label class="form-label" for="accountType">Account Type<span class="astrict">*</span></label>
            <select class="form-control" formControlName="accountType" id="accountType">
      <option value="">Account type</option>
      <option value="Savings Account">Savings Account</option>
      <option value="Current Account">Current Account</option>
      <option value="Business Account">Business Account</option>
      <option value="Cheque Account">Cheque Account</option>
      <option value="Transmission Account">Transmission Account</option>
    </select>
            <div class="for-validation text-danger" *ngIf="businessform.get('accountType')?.hasError('required') && businessform.get('accountType')?.touched">
      *Enter your account type.
    </div>
  </div>
          <div class="form-field">
            <label class="form-label" for="accountName">Account Name<span class="astrict">*</span></label>
            <input type="text" class="form-control" formControlName="accountName" (keypress)="preventSpace($event)" placeholder="Enter account name" id="accountName" />
            <div class="for-validation text-danger" *ngIf="businessform.get('accountName')?.hasError('required') && businessform.get('accountName')?.touched">
      *Enter your account name.
    </div>
  </div>
</div>
      </div>

      <div class="action-buttons">
        <button class="btn-secondary-action" type="button" (click)="navigateToProfile()">
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
        <button class="btn-primary-action" type="button" *ngIf="!loading" (click)="load(); updateBusinessDetail()">
          <i class="fa fa-check mr-2"></i>Update Business
                    </button>
        <button class="btn-primary-action is-loading" type="button" *ngIf="loading" disabled>
          <i class="fa fa-spinner fa-spin mr-2"></i>Loading...
                    </button>
                </div>
    </form>
  </section>
</div>

